import { type PropsWithChildren, useEffect } from 'react';
import { Navigate } from 'react-router';

import { getAnalyticsUserRole } from '~entities/ampli';
import { growthBookInstance } from '~entities/growthbook';

import { ROUTES } from '~shared/config/routes';
import { Loader } from '~shared/ui/loader';

import * as Sentry from '@breeze/web-lib-sentry';
import Clarity from '@microsoft/clarity';

import { useUserInfo } from '../api';
import { UserInfo } from '../model';

type RoleCheckFn = (userInfo: UserInfo) => boolean;

interface RoleGuardProps {
  roles: RoleCheckFn[];
}

export const RequireRole = ({
  children,
  roles,
}: PropsWithChildren<RoleGuardProps>) => {
  const userInfoQuery = useUserInfo();

  useEffect(() => {
    if (userInfoQuery.data?.personId) {
      Clarity.setTag('person_id', userInfoQuery.data.personId);
      Clarity.setTag('role', getAnalyticsUserRole(userInfoQuery.data) ?? '');
      Sentry.setTag('personId', userInfoQuery.data.personId);
      growthBookInstance.updateAttributes({
        personId: userInfoQuery.data.personId,
      });
    }
  }, [userInfoQuery.data]);

  if (userInfoQuery.data) {
    const hasRequiredRole = roles.some((roleCheck) =>
      roleCheck(userInfoQuery.data)
    );

    if (hasRequiredRole) {
      return children;
    }

    return <Navigate to={ROUTES.root} replace />;
  }

  return <Loader />;
};
